import api from '../api'

const baseUrl = '/BizSchool/api/Admin'
const postUrl = '/BizSchool/api/Post'

const dadbanArticleProvider = {
  getAllArticles(params = {}) {
    return api.post(`${baseUrl}/ArticleTable`, {
      params,
    })
  },

  getArticle(id) {
    return api.get(`${baseUrl}/GetArticle/${id}`)
  },

  getArticleCategory() {
    return api.get(`${baseUrl}/ArticleCategory`)
  },

  addArticle(params) {
    return api.post(`${baseUrl}/Article`, params)
  },

  updateArticle(params = {}) {
    return api.put(`${baseUrl}/Article`, params)
  },

  deleteArticle(params) {
    return api.delete(`${baseUrl}/Article/${params}`)
  },
  addPost(params) {
    return api.post(`${postUrl}/Add`, params)
  },
  updatePost(params) {
    return api.post(`${postUrl}/Edit`, params)
  },
  getPost(id) {
    return api.get(`${postUrl}/Get/${id}`)
  },
  deletePost(id) {
    return api.delete(`${postUrl}/Delete/${id}`)
  },
}

export default dadbanArticleProvider
